import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { vouchersApi } from '../../lib/api';
import { VoucherForm } from '../../components/voucher/VoucherForm';
import { toast } from 'sonner';

export const CreateVoucherPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  // Determine base path based on current route (for accounts vs employee)
  const isAccountsPath = location.pathname.startsWith('/accounts');
  const basePath = isAccountsPath ? '/accounts/vouchers' : '/vouchers';

  const handleSubmit = async (data) => {
    setLoading(true);
    try {
      // Extract pending files before creating voucher
      const { pendingFiles, ...voucherData } = data;
      
      // Create the voucher first
      const voucher = await vouchersApi.create(voucherData);
      
      // Upload any pending files
      if (pendingFiles && pendingFiles.length > 0) {
        toast.info(`Uploading ${pendingFiles.length} file(s)...`);
        
        let uploadedCount = 0;
        for (const file of pendingFiles) {
          try {
            await vouchersApi.uploadAttachment(voucher.id, file);
            uploadedCount++;
          } catch (error) {
            console.error('Failed to upload file:', file.name, error);
            toast.error(`Failed to upload: ${file.name}`);
          }
        }
        
        if (uploadedCount > 0) {
          toast.success(`${uploadedCount} file(s) uploaded successfully`);
        }
      }
      
      toast.success('Voucher created successfully');
      navigate(`${basePath}/${voucher.id}`);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create voucher');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="create-voucher-page">
      <div>
        <h1 className="text-2xl font-heading font-semibold tracking-tight">Create New Voucher</h1>
        <p className="text-muted-foreground text-sm mt-1">
          Fill in the details to create a new payment voucher
        </p>
      </div>

      <VoucherForm
        onSubmit={handleSubmit}
        onCancel={() => navigate(basePath)}
        isLoading={loading}
      />
    </div>
  );
};

export default CreateVoucherPage;
